(function () {
  var SECTION_SELECTOR = '.oddit-section-collection-carousel';
  var TRACK_SELECTOR = '.oddit-section-collection-carousel__track';
  var INDICATOR_CLASS = 'oddit-section-collection-carousel__indicator';
  var ACTIVE_CLASS = 'oddit-section-collection-carousel__indicator--active';
  var HIDDEN_ARROW_CLASS = 'oddit-section-collection-carousel__arrow--hidden';
  var FITS_CLASS = 'oddit-section-collection-carousel__track--fits';

  var sectionState = new Map();

  // Pagination works in "pages" — one page is a single viewport-width of the
  // scrollable track — so the dots reflect how many scroll stops exist, not how
  // many cards there are. On a wide viewport several cards share one page.
  function getPageMetrics(track) {
    var pageSize = track.clientWidth;
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var count = 1;
    if (pageSize > 0 && maxScroll > 0) {
      count = Math.ceil(maxScroll / pageSize) + 1;
    }
    return { pageSize: pageSize, maxScroll: maxScroll, count: count };
  }

  function getCurrentPage(track) {
    var m = getPageMetrics(track);
    if (m.pageSize <= 0) return 0;
    // At (or within 2px of) the end, the last page can't advance a full width,
    // so clamp to the final page rather than rounding short of it.
    if (m.maxScroll > 0 && track.scrollLeft >= m.maxScroll - 2) {
      return m.count - 1;
    }
    var page = Math.round(track.scrollLeft / m.pageSize);
    return Math.max(0, Math.min(page, m.count - 1));
  }

  function scrollToPage(track, page, state) {
    var m = getPageMetrics(track);
    var clamped = Math.max(0, Math.min(page, m.count - 1));
    // The final page snaps to the true max scroll (the last page is usually a
    // partial width), every earlier page is an exact multiple of the width.
    var left = clamped >= m.count - 1 ? m.maxScroll : clamped * m.pageSize;
    state.programmaticScroll = true;
    track.scrollTo({ left: left, behavior: 'smooth' });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        state.programmaticScroll = false;
      });
    });
  }

  function updateIndicators(section, activePage) {
    var indicators = section.querySelectorAll('.' + INDICATOR_CLASS);
    indicators.forEach(function (dot, index) {
      var isActive = index === activePage;
      dot.classList.toggle(ACTIVE_CLASS, isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function updateArrows(section, page, count) {
    var prev = section.querySelector('[data-collection-carousel-prev]');
    var next = section.querySelector('[data-collection-carousel-next]');
    // Prev only appears once you've left the first page; next disappears on the
    // last page.
    if (prev) prev.classList.toggle(HIDDEN_ARROW_CLASS, page <= 0);
    if (next) next.classList.toggle(HIDDEN_ARROW_CLASS, page >= count - 1);
  }

  // On very wide screens every card fits, so the bleed-right layout has nothing
  // to bleed into — flag it so CSS can centre the track instead.
  function updateFit(track) {
    var fits = track.scrollWidth - track.clientWidth <= 1;
    track.classList.toggle(FITS_CLASS, fits);
  }

  // Sync the active dot and arrow visibility to the current scroll position.
  function updateControls(section, track) {
    updateFit(track);
    var page = getCurrentPage(track);
    var count = getPageMetrics(track).count;
    updateIndicators(section, page);
    updateArrows(section, page, count);
  }

  // (Re)build the dot buttons so their number matches the current page count,
  // which changes with viewport width. Only rebuilds when the count changed.
  function buildIndicators(section, track, state) {
    var container = section.querySelector('[data-collection-carousel-indicators]');
    if (!container) return;
    // Padding changes with the fit state, so settle it before counting pages.
    updateFit(track);
    var count = getPageMetrics(track).count;
    var existing = container.querySelectorAll('.' + INDICATOR_CLASS);
    if (existing.length === count) return;

    container.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = INDICATOR_CLASS;
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.setAttribute('aria-selected', 'false');
      (function (target) {
        dot.addEventListener('click', function () {
          scrollToPage(track, target, state);
          updateControls(section, track);
        });
      })(i);
      container.appendChild(dot);
    }
    // Hide the whole dot bar when everything fits on one page.
    container.style.display = count <= 1 ? 'none' : '';
  }

  // Desktop click-and-drag scrolling. Mouse only — touch/pen keep native
  // momentum scrolling. A press only becomes a drag after DRAG_THRESHOLD px of
  // movement, and the click that follows a drag is swallowed so links/cards
  // inside the track don't activate at the end of a drag gesture.
  function initDragScroll(section, track, state) {
    var DRAG_CLASS = 'oddit-section-collection-carousel__track--dragging';
    var DRAG_THRESHOLD = 5; // px of movement before a press becomes a drag
    var pointerFine = window.matchMedia('(hover: hover) and (pointer: fine)');

    var isDown = false;
    var isDragging = false;
    var suppressClick = false;
    var startX = 0;
    var startScroll = 0;
    var activePointerId = null;

    function onPointerDown(e) {
      // Only hijack mouse input; touch/pen keep native momentum scrolling.
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (!pointerFine.matches) return;
      isDown = true;
      isDragging = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      activePointerId = e.pointerId;
    }

    function onPointerMove(e) {
      if (!isDown || e.pointerId !== activePointerId) return;
      var dx = e.clientX - startX;
      if (!isDragging) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        isDragging = true;
        track.classList.add(DRAG_CLASS);
        try {
          track.setPointerCapture(activePointerId);
        } catch (err) {}
      }
      e.preventDefault();
      track.scrollLeft = startScroll - dx;
    }

    function endDrag(e) {
      if (!isDown) return;
      if (e && activePointerId !== null && e.pointerId !== activePointerId) return;
      isDown = false;
      if (activePointerId !== null) {
        try {
          track.releasePointerCapture(activePointerId);
        } catch (err) {}
      }
      activePointerId = null;
      if (isDragging) {
        isDragging = false;
        suppressClick = true;
        track.classList.remove(DRAG_CLASS);
        // Restore smooth behaviour + snap to the nearest page.
        var page = getCurrentPage(track);
        scrollToPage(track, page, state);
        updateControls(section, track);
      }
    }

    // A click fires after the drag's pointerup — swallow it so cards/links
    // inside the track don't activate at the end of a drag gesture.
    function onClickCapture(e) {
      if (!suppressClick) return;
      suppressClick = false;
      e.preventDefault();
      e.stopPropagation();
    }

    // Stop the browser's native image/text drag from stealing the gesture.
    function onDragStart(e) {
      if (isDown) e.preventDefault();
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('click', onClickCapture, true);
    track.addEventListener('dragstart', onDragStart);

    return {
      destroy: function () {
        track.removeEventListener('pointerdown', onPointerDown);
        track.removeEventListener('pointermove', onPointerMove);
        track.removeEventListener('pointerup', endDrag);
        track.removeEventListener('pointercancel', endDrag);
        track.removeEventListener('pointerleave', endDrag);
        track.removeEventListener('click', onClickCapture, true);
        track.removeEventListener('dragstart', onDragStart);
        track.classList.remove(DRAG_CLASS);
      }
    };
  }

  function debounce(fn, wait) {
    var timerId = null;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timerId);
      timerId = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function initSection(section) {
    if (!section || sectionState.has(section)) return;

    var track = section.querySelector(TRACK_SELECTOR);
    if (!track) return;

    var state = {
      programmaticScroll: false,
      handlers: {}
    };

    // Sync the active dot + arrow visibility when the user scrolls the track.
    var handleScroll = debounce(function () {
      updateControls(section, track);
    }, 100);
    track.addEventListener('scroll', handleScroll, { passive: true });
    state.handlers.scroll = handleScroll;

    // Prev / next arrows step one page at a time.
    var prevBtn = section.querySelector('[data-collection-carousel-prev]');
    var nextBtn = section.querySelector('[data-collection-carousel-next]');

    function handlePrev() {
      scrollToPage(track, getCurrentPage(track) - 1, state);
      updateControls(section, track);
    }

    function handleNext() {
      scrollToPage(track, getCurrentPage(track) + 1, state);
      updateControls(section, track);
    }

    if (prevBtn) prevBtn.addEventListener('click', handlePrev);
    if (nextBtn) nextBtn.addEventListener('click', handleNext);
    state.handlers.prev = handlePrev;
    state.handlers.next = handleNext;

    // Build the page dots and sync all controls to the starting position
    // (leftmost page 0 is active on load).
    buildIndicators(section, track, state);
    updateControls(section, track);

    // Recompute page count / controls when the viewport (and card visibility)
    // changes, then re-snap to the current page.
    var handleResize = debounce(function () {
      buildIndicators(section, track, state);
      scrollToPage(track, getCurrentPage(track), state);
      updateControls(section, track);
    }, 150);
    window.addEventListener('resize', handleResize);
    state.handlers.resize = handleResize;

    // Enable desktop click-and-drag scrolling.
    state.drag = initDragScroll(section, track, state);

    sectionState.set(section, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    if (state.drag) state.drag.destroy();
    if (state.handlers && state.handlers.resize) {
      window.removeEventListener('resize', state.handlers.resize);
    }
    sectionState.delete(section);
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector
      ? e.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector
      ? e.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) destroySection(section);
  });
})();
